import type { ItemProviderDataSection } from '../../types/item-provider.tsx';

export const hasItems = (section: ItemProviderDataSection): boolean =>
	!!(section.items && section.items.length > 0);
